/**
 * Homepage-only: eager-load product + footer images for Safari screenshots.
 */
(function prepareHomepageForSafariScreenshot() {
  function start() {
    if (!document.body?.classList.contains('template-index')) return;

    document
      .querySelectorAll('.card-gallery slideshow-slide, .section-resource-list')
      .forEach((node) => {
        if (node instanceof HTMLElement) {
          node.style.contentVisibility = 'visible';
        }
      });

  /**
   * @param {HTMLImageElement} img
   * @returns {Promise<void>}
   */
    function warmImage(img) {
      img.loading = 'eager';
      img.removeAttribute('loading');

      if (img.complete && img.naturalWidth > 0) {
        return img.decode?.().catch(() => undefined) ?? Promise.resolve();
      }

      return new Promise((resolve) => {
        const finish = () => {
          const decoded = img.decode?.().catch(() => undefined) ?? Promise.resolve();
          decoded.then(() => resolve()).catch(() => resolve());
        };

        img.addEventListener('load', finish, { once: true });
        img.addEventListener('error', finish, { once: true });
      });
    }

    const images = document.querySelectorAll(
      '.section-resource-list img, .card-gallery img, footer img'
    );

    Promise.allSettled([...images].map((img) => warmImage(img)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', start);
})();
